import { ReactNode } from "react";
import { en } from "../i18n/en";

/** A neutral full-page loading state, e.g. while the session is restored (specs/12 FR-82). */
export function LoadingScreen() {
  return (
    <div role="status" className="flex min-h-screen items-center justify-center text-slate-400">
      {en.loading}
    </div>
  );
}

/** A full-page message, with an optional action such as Retry. */
export function MessageScreen({
  title,
  body,
  action,
}: {
  title: string;
  body: string;
  action?: { label: string; onClick: () => void };
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center">
      <h1 className="text-xl font-semibold">{title}</h1>
      <p className="max-w-sm text-slate-300">{body}</p>
      {action && (
        <button type="button" onClick={action.onClick} className={buttonClass}>
          {action.label}
        </button>
      )}
    </div>
  );
}

export const buttonClass =
  "rounded-md bg-sky-600 px-4 py-2 font-semibold text-white hover:bg-sky-500 disabled:opacity-60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-400";

export const secondaryButtonClass =
  "rounded-md border border-slate-600 px-4 py-2 font-semibold text-slate-100 hover:bg-slate-800 disabled:opacity-60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-400";

/** A short message that disappears by itself (role="alert" so screen readers announce it). */
export function Toast({ children }: { children: ReactNode }) {
  return (
    <div
      role="alert"
      className="fixed inset-x-4 bottom-[calc(6rem+env(safe-area-inset-bottom))] z-40 mx-auto max-w-md rounded-lg bg-red-900 px-4 py-3 text-sm text-red-50 shadow-lg"
    >
      {children}
    </div>
  );
}
